import styled, { css } from "styled-components";
import faqs from "./FaqData";
import { SectionContainer, SectionTitle } from "screens/Homepage/styles";
import { typography } from "screens/Homepage/components/typography";

const FAQ = () => {
  return (
    <SectionContainer>
      <SectionTitle>Frequently asked questions</SectionTitle>
      <QuestionAnswerWrapper>
        {faqs.map((item, index) => (
          <QuestionAnswerCard key={`faq-${index}`}>
            <Question>{item.question}</Question>
            <Answer>{item.answer}</Answer>
          </QuestionAnswerCard>
        ))}
      </QuestionAnswerWrapper>
    </SectionContainer>
  );
};

export default FAQ;

const QuestionAnswerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  max-width: 800px;
`;

const QuestionAnswerCard = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 24px;
      box-sizing: border-box;
      gap: 12px;
      background-color: ${theme.colors.gray2};
      border: 1px solid ${theme.colors.gray6};
      border-radius: 8px;
      width: 100%;
    `;
  }}
`;

const Question = styled.h5`
  ${({ theme }) => css`
    all: unset;
    color: ${theme.colors.gray12};
    ${typography.title20};

    @media (max-width: ${theme.breakpoints.sm}px) {
      ${typography.title18};
    }
  `}
`;

const Answer = styled.p`
  ${({ theme }) => css`
    all: unset;
    color: ${theme.colors.gray11};
    ${typography.textBaseLight};
  `}
`;
